/* istanbul ignore file */
import React from 'react';
import { ShowDate } from 'framework/ui/ui-builder';
import { useShowContext } from 'framework/show';
import TimelineRecordAuthorWithAccessCheck from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/TimelineRecordAuthorWithAccessCheck';
import { DATE_FORMAT } from 'framework/utils';
import { Box } from '@mui/material';
import { timelineCardDateTimeSx, timelineCardHeaderSx } from './baseTimelineRecordSx';

interface TimeLineHeaderProps {
  createdAtSource?: string;
  actionName?: string | ((entity: any) => string);
  timelineId?: string;
  entity?: any;
  isAuthorAccessChecked?: boolean;
}

const TimelineRecordHeader: React.FC<TimeLineHeaderProps> = ({ actionName, createdAtSource = null }) => {
  const { data: entity } = useShowContext();
  const createdAt = entity.getValueBySource(createdAtSource ?? 'createdAt');
  const createdById = entity.getValueBySource('createdById');
  const createdByName = entity.getValueBySource('createdByName');

  const resultActionName = typeof actionName === 'function' ? actionName(entity.getData()) : actionName;

  return (
    <Box sx={timelineCardHeaderSx}>
      <Box>
        <Box sx={timelineCardDateTimeSx}>
          <ShowDate dateUTC={createdAt} format={DATE_FORMAT.FULL} />
        </Box>
        <TimelineRecordAuthorWithAccessCheck id={createdById} name={createdByName} /> {resultActionName}
      </Box>
    </Box>
  );
};

export default TimelineRecordHeader;
